import { useMemo } from 'react';
import { standardCachingQueryOptions } from 'pos-client/utils/standardCachingQueryOptions.ts';
import { trpc } from 'pos-client/utils/trpc.ts';
import type { JobTypeModel } from 'pos-shared/models/jobTypeSchema.ts';

export const useServiceJobTypes = () => {
  const {
    data,
    isLoading: isLoadingJobTypes,
    isFetching: isFetchingJobTypes,
  } = trpc.findJobTypes.useQuery(
    {
      isActive: true,
      pageNumber: 1,
      resultsPerPage: 1000,
      searchText: '',
    },
    standardCachingQueryOptions
  );

  const jobTypeOptions = useMemo(
    () =>
      (data?.results || []).map((jt) => {
        return {
          description: jt.name,
          id: jt.id,
          label: jt.name,
          value: jt.name,
        }; // TODO: localise
      }),
    [data]
  );

  const jobTypesForStatic = useMemo(
    () =>
      (data?.results || [])
        .filter((jt) => jt.serviceType === 'Static')
        .map((jt) => {
          return { name: jt.name, value: jt.name };
        }),
    [data]
  );

  const jobTypesForMobile = useMemo(
    () =>
      (data?.results || [])
        .filter((jt) => jt.serviceType === 'Mobile')
        .map((jt) => {
          return { name: jt.name, value: jt.name };
        }),
    [data]
  );

  return {
    jobTypes: (data?.results ?? []) as JobTypeModel[],
    jobTypesForStatic,
    jobTypesForMobile,
    isLoadingJobTypes,
    jobTypeOptions,
    isFetchingJobTypes,
  };
};
